import React, { useEffect, useState } from 'react';
import WebRTCPlayerOvenMedia from '../WebRTCPlayerOvenMedia';
import { useCreateDeviceStream } from '../../services/Devices/hooks/useMutation';
import DeviceConnectionStreamContainerComponent from '../DeviceConnectionStreamContainerComponent';

interface DeviceDirectConnectionStreamComponentProps {
  deviceId?: number;
  isEnableVideo?: boolean;
  deviceName?: string;
}

const DeviceDirectConnectionStreamComponent = ({
  deviceId,
  deviceName,
  isEnableVideo,
}: DeviceDirectConnectionStreamComponentProps) => {
  const [isEnableRender, setIsEnableRender] = useState(false);
  const [isError, setIsError] = useState(false);
  const { mutateAsync: mutateCreateDeviceStreamAsync } =
    useCreateDeviceStream();

  useEffect(() => {
    if (deviceId && isEnableVideo)
      mutateCreateDeviceStreamAsync(deviceId, {
        onError: () => setIsError(true),
      }).then(() => {
        setTimeout(() => {
          setIsEnableRender(true);
        }, 3000);
      });
  }, [deviceId, isEnableVideo]);

  return (
    <DeviceConnectionStreamContainerComponent
      isEnableVideo={isEnableVideo}
      handleVideo={
        isEnableRender && deviceName ? (
          <WebRTCPlayerOvenMedia
            streamUrl={deviceName.replaceAll(' ', '').toLowerCase() + deviceId}
          />
        ) : (
          <></>
        )
      }
      isError={isError}
      isLoading={!isEnableRender}
    />
  );
};
export default DeviceDirectConnectionStreamComponent;
